import {
  ChangeDetectionStrategy,
  Component,
  output,
  inject,
} from '@angular/core';
import { UserFormComponent } from '../../components/user-form/user-form.component';
import { AlertsComponent, AlertsService } from '@web/shared/ui';
import { UserFormData } from '../../models/user-form-data';
import { once } from '@web/utils';
import { UserDataSourceService } from '../../services/user-data-source.service';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpErrorService } from '@web/common';

@Component({
  selector: 'app-user-create',
  imports: [UserFormComponent, AlertsComponent],
  templateUrl: './user-create.component.html',
  styleUrl: './user-create.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserCreateComponent {
  private readonly userDataSource = inject(UserDataSourceService);
  private readonly httpError = inject(HttpErrorService);
  private readonly alerts = inject(AlertsService);

  public readonly submitSuccessEvent = output<void>();

  public handleSubmitClick(data: UserFormData): void {
    this.userDataSource
      .createByFormData(data)
      .pipe(once())
      .subscribe({
        next: () => {
          this.notifySubmitSuccessEvent();
        },
        error: (response) => this.showFailureAlertByResponse(response),
      });
  }

  private notifySubmitSuccessEvent(): void {
    this.submitSuccessEvent.emit();
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    this.alerts.showMultiple((builder) =>
      this.httpError
        .extract(response)
        .messages()
        .map((message) => builder.buildFailure(message)),
    );
  }
}
